<div style="padding-top: 200px; text-align: center;">
  <img src="/assets/img/logo.png" />
  <br><br>
{{'component.preload.wait' | translate}}
</div>
